export const CREATE_DRAFT_REQUEST = 'writing/CREATE_DRAFT_REQUEST';
export const CREATE_DRAFT_SUCCESS = 'writing/CREATE_DRAFT_SUCCESS';
export const CREATE_DRAFT_FAILURE = 'writing/CREATE_DRAFT_FAILURE';

export const UPDATE_DRAFT_REQUEST = 'writing/UPDATE_DRAFT_REQUEST';
export const UPDATE_DRAFT_SUCCESS = 'writing/UPDATE_DRAFT_SUCCESS';
export const UPDATE_DRAFT_FAILURE = 'writing/UPDATE_DRAFT_FAILURE';

export const FETCH_DRAFT_REQUEST = 'outbox/FETCH_DRAFT_REQUEST';
export const FETCH_DRAFT_SUCCESS = 'outbox/FETCH_DRAFT_SUCCESS';
export const FETCH_DRAFT_FAILURE = 'outbox/FETCH_DRAFT_FAILURE';

export const FETCH_DRAFTS_REQUEST = 'outbox/FETCH_DRAFTS_REQUEST';
export const FETCH_DRAFTS_SUCCESS = 'outbox/FETCH_DRAFTS_SUCCESS';
export const FETCH_DRAFTS_FAILURE = 'outbox/FETCH_DRAFTS_FAILURE';

export const DELETE_DRAFT_REQUEST = 'outbox/DELETE_DRAFT_REQUEST';
export const DELETE_DRAFT_SUCCESS = 'outbox/DELETE_DRAFT_SUCCESS';
export const DELETE_DRAFT_FAILURE = 'outbox/DELETE_DRAFT_FAILURE';

export const DELETE_DRAFTS_REQUEST = 'outbox/DELETE_DRAFTS_REQUEST';
export const DELETE_DRAFTS_SUCCESS = 'outbox/DELETE_DRAFTS_SUCCESS';
export const DELETE_DRAFTS_FAILURE = 'outbox/DELETE_DRAFTS_FAILURE';

export const FETCH_DRAFT_FILE_SUCCESS = 'outbox/FETCH_DRAFT_FILE_SUCCESS';
export const FETCH_DRAFT_FILE_FAILURE = 'outbox/FETCH_DRAFT_FILE_FAILURE';

export const CLEAR_DRAFTS_ERROR = 'outbox/CLEAR_DRAFTS_ERROR';
export const CLEAR_CREATED_ERROR_DRAFT = 'outbox/CLEAR_CREATED_ERROR_DRAFT';
export const CLEAR_UPDATED_ERROR_DRAFT = 'outbox/CLEAR_UPDATED_ERROR_DRAFT';
export const CLEAR_DELETED_ERROR_DRAFTS = 'outbox/CLEAR_DELETED_ERROR_DRAFTS';
export const CLEAR_DRAFT_ERROR = 'outbox/CLEAR_DRAFT_ERROR';

export const INIT_CREATED = 'outbox/INIT_CREATED';

export const INIT_DELETED = 'outbox/INIT_DELETED';

export const INIT_UPDATED = 'outbox/INIT_UPDATED';

export const INIT_DRAFT = 'outbox/INIT_DRAFT';

export const INIT_DRAFTS = 'outbox/INIT_DRAFTS';

export const createDraftRequest = (payload = {}) => ({
  type: CREATE_DRAFT_REQUEST,
  payload,
});
export const createDraftSuccess = (payload = {}) => ({
  type: CREATE_DRAFT_SUCCESS,
  payload,
});
export const createDraftFailure = (payload = {}) => ({
  type: CREATE_DRAFT_FAILURE,
  payload,
});

export const updateDraftRequest = (payload = {}) => ({
  type: UPDATE_DRAFT_REQUEST,
  payload,
});
export const updateDraftSuccess = (payload = {}) => ({
  type: UPDATE_DRAFT_SUCCESS,
  payload,
});
export const updateDraftFailure = (payload = {}) => ({
  type: UPDATE_DRAFT_FAILURE,
  payload,
});

export const fetchDraftRequest = (payload = {}) => ({
  type: FETCH_DRAFT_REQUEST,
  payload,
});
export const fetchDraftSuccess = (payload = {}) => ({
  type: FETCH_DRAFT_SUCCESS,
  payload,
});
export const fetchDraftFailure = (payload = {}) => ({
  type: FETCH_DRAFT_FAILURE,
  payload,
});

export const fetchDraftsRequest = (payload = {}) => ({
  type: FETCH_DRAFTS_REQUEST,
  payload,
});
export const fetchDraftsSuccess = (payload = {}) => ({
  type: FETCH_DRAFTS_SUCCESS,
  payload,
});
export const fetchDraftsFailure = (payload = {}) => ({
  type: FETCH_DRAFTS_FAILURE,
  payload,
});

export const deleteDraftRequest = (payload = {}) => ({
  type: DELETE_DRAFT_REQUEST,
  payload,
});
export const deleteDraftSuccess = (payload = {}) => ({
  type: DELETE_DRAFT_SUCCESS,
  payload,
});
export const deleteDraftFailure = (payload = {}) => ({
  type: DELETE_DRAFT_FAILURE,
  payload,
});

export const deleteDraftsRequest = (payload = {}) => ({
  type: DELETE_DRAFTS_REQUEST,
  payload,
});
export const deleteDraftsSuccess = (payload = {}) => ({
  type: DELETE_DRAFTS_SUCCESS,
  payload,
});
export const deleteDraftsFailure = (payload = {}) => ({
  type: DELETE_DRAFTS_FAILURE,
  payload,
});

export const fetchDraftFileSuccess = (payload = {}) => ({
  type: FETCH_DRAFT_FILE_SUCCESS,
  payload,
});
export const fetchDraftFileFailure = (payload = {}) => ({
  type: FETCH_DRAFT_FILE_FAILURE,
  payload,
});

export const clearDraftsError = () => ({
  type: CLEAR_DRAFTS_ERROR,
});
export const clearCreatedErrorDraft = () => ({
  type: CLEAR_CREATED_ERROR_DRAFT,
});
export const clearUpdatedErrorDraft = () => ({
  type: CLEAR_UPDATED_ERROR_DRAFT,
});
export const clearDeletedErrorDrafts = () => ({
  type: CLEAR_DELETED_ERROR_DRAFTS,
});
export const clearDraftError = () => ({
  type: CLEAR_DRAFT_ERROR,
});

export const initCreated = (payload = {}) => ({
  type: INIT_CREATED,
  payload,
});

export const initDeleted = (payload = {}) => ({
  type: INIT_DELETED,
  payload,
});

export const initUpdated = (payload = {}) => ({
  type: INIT_UPDATED,
  payload,
});

export const initDraft = (payload = {}) => ({
  type: INIT_DRAFT,
  payload,
});

export const initDrafts = (payload = {}) => ({
  type: INIT_DRAFTS,
  payload,
});
